import api, {VersionedAPIPath} from "@/api/api";

export default {
    //USES WEB-CONTROLLERS
    createSession() {
        return api.get('/sanctum/csrf-cookie');
    },
    //USES WEB-CONTROLLERS
    login($params) {
        return api.post('/login', $params)
    },
    //USES WEB-CONTROLLERS
    verifyTwoFactorChallenge($params) {
        return api.post('/two-factor-challenge', $params)
    },
    //USES API-CONTROLLERS
    getCurrentUser(){
        return api.get(VersionedAPIPath+'/user/me');
    },
    //USES WEB-CONTROLLERS
    logout() {
        return api.post('/logout');
    }
}